<ng-http-loader></ng-http-loader>
<router-outlet />
